
import { hyphenatedCurrentLocale } from 'bits/current_locale'
import relativeTime from 'bits/relative_time'
import { Component, Prop, Vue } from 'bits/vue'

/**
 * Displays the duration relative to given date/time.
 */

@Component({})
export default class RelativeTime extends Vue {
  /**
   * Display the duration from this date/time.
   */
  @Prop() datetime!: string | number | Date

  /**
   * The format to display the relative time in.
   */
  @Prop({ default: 'short' }) dateformat!: 'short' | 'long'

  get relativeTime(): string {
    return relativeTime(this.datetime, this.dateformat)
  }

  get actualTime(): string {
    const date = new Date(this.datetime)
    const formattedTime = date.toLocaleString(hyphenatedCurrentLocale, { hour: 'numeric', minute: 'numeric' })
    const formattedDate = date.toLocaleString(hyphenatedCurrentLocale, {
      year: 'numeric',
      day: 'numeric',
      month: 'long',
    })
    return `${formattedTime} • ${formattedDate}`
  }
}
